//reducer is where state goes
// action dispatch to reducer
//e.g. getItems dispatch to reducer
// send response (state) from server to reducer

import {
  GET_PROJECTS,
  ADD_PROJECT,
  DELETE_PROJECT,
  PROJECTS_LOADING,
  UPDATE_PROJECT,
  LOGOUT_SUCCESS,
  UPDATE_CONTACTLIST,
  PROJ_ERROR,
  SEND_INVITATION,
  PROJECT_NOTIFICATION,
  ADD_FOLDER,
  MODIFY_FOLDER,
  DELETE_FOLDER,
  UPDATE_FOLDER,
} from "../actions/types";

let projectsIni = null;
let folderIni = null;

try {
  projectsIni = JSON.parse(localStorage.getItem("projects"));
} catch (e) {
  console.log("localstorage error", e);
}

try {
  folderIni = JSON.parse(localStorage.getItem("folder"));
} catch (e) {
  console.log("localstorage error", e);
}

const initialState = {
  projects: null, //projectsIni, if we user ini from storage, then wrong information can be shown
  //we need to put null otherwise projects are displayer without folders
  isLoading: false,
  contactList: [],
  projError: "",
  projNotification: "",
  folder: null, //folderIni,
  // Bumped on every local folder mutation (add/modify/delete). A folder
  // list fetched by getItems (background poll) or getProjects can take
  // several seconds (or longer with a retry) to resolve - if it was
  // in flight when the user added/edited/deleted a folder, its response
  // reflects the OLD list and would otherwise silently clobber the
  // mutation once it lands. Fetches capture this value when the request
  // is issued (baseVersion) and are ignored on arrival if a mutation
  // happened since (see UPDATE_FOLDER / GET_PROJECTS below).
  folderVersion: 0,
  // when we fetch data takes some ms to get
};

//will later get state from api

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_FOLDER:
      // Dispatched with the folder list from a getItems response, alongside
      // the folderVersion in effect when that request was issued
      // (baseVersion). If a local mutation (add/modify/delete) has bumped
      // folderVersion since, this response is stale - applying it would
      // silently undo the mutation, so skip it instead.
      if (
        action.payload?.baseVersion !== undefined &&
        action.payload.baseVersion < state.folderVersion
      ) {
        return state;
      }
      let folder4 = action.payload?.folder;
      localStorage.setItem("folder", JSON.stringify(folder4));
      return {
        ...state,
        folder: folder4,
      };
    case ADD_FOLDER:
      let folder1 = state.folder;
      folder1.push(action.payload);
      localStorage.setItem("folder", JSON.stringify(folder1));
      return {
        ...state,
        folder: folder1,
        folderVersion: state.folderVersion + 1,
      };
    case MODIFY_FOLDER:
      let folder2 = state.folder;

      let fIndF = folder2.findIndex((x) => x._id === action.payload._id);
      if (fIndF > -1) {
        folder2[fIndF] = action.payload;
      }
      localStorage.setItem("folder", JSON.stringify(folder2));

      return {
        ...state,
        folder: folder2,
        folderVersion: state.folderVersion + 1,
      };
    case DELETE_FOLDER:
      let folder3 = state.folder;

      folder3 = folder3.filter((x) => x._id !== action.payload);
      localStorage.setItem("folder", JSON.stringify(folder3));
      return {
        ...state,
        folder: folder3,
        folderVersion: state.folderVersion + 1,
      };
    case PROJECT_NOTIFICATION:
      return {
        ...state,
        projectNotification: action.payload,
      };
    case PROJ_ERROR:
      return {
        ...state,
        projError: action.payload,
        // before request items_loading was set to true
      };
    // checking action from itemActions -> type is name of action
    case UPDATE_CONTACTLIST:
      return {
        ...state,
        contactList: action.payload,
        // before request items_loading was set to true
      };
    case SEND_INVITATION:
      let fInd = state.projects.findIndex((x) => x._id === action.payload._id);
      let projState = state.projects;
      if (fInd > -1) {
        projState[fInd] = action.payload;
      } else {
        projState.push(action.payload);
      }
      localStorage.setItem("projects", JSON.stringify(projState));
      return {
        ...state,
        projects: projState,
      };
    case GET_PROJECTS:
      localStorage.setItem("projects", JSON.stringify(action.payload.projects));
      // Same staleness check as UPDATE_FOLDER above - a getProjects response
      // in flight while the user adds/modifies/deletes a folder is stale by
      // the time it lands and would otherwise clobber that mutation.
      let folder = state.folder;
      if (
        action.payload?.baseVersion === undefined ||
        action.payload.baseVersion >= state.folderVersion
      ) {
        // /projects only returns the folders that projects reference, never
        // the worksheet ("ws") folders that ItemView shows (those come from
        // getItems). Replacing state.folder wholesale therefore wipes every
        // ws folder whenever this response lands after getItems' - keep them.
        const projectFolders = Array.isArray(action.payload.folder)
          ? action.payload.folder
          : [];
        const keptWsFolders = (state.folder || []).filter(
          (f) =>
            f.folderType === "ws" &&
            !projectFolders.some((pf) => pf._id === f._id),
        );
        folder = [...projectFolders, ...keptWsFolders];
        localStorage.setItem("folder", JSON.stringify(folder));
      }
      let projects = action.payload.projects;
      return {
        ...state,
        projects,
        folder,
        isLoading: false,
        // before request items_loading was set to true
      };
    case DELETE_PROJECT:
      // localStorage.setItem("projects", projState);
      let locprojstate = state.projects.filter(
        (project) => project._id !== action.payload
      );
      localStorage.setItem("projects", JSON.stringify(locprojstate));
      return {
        ...state,
        projects: locprojstate,
      };
    case ADD_PROJECT:
      let locprojstate2 = [...state.projects, action.payload];

      return {
        ...state,
        projects: locprojstate2,
        // ... -> because hardcopy we cannot modify it
      };
    case PROJECTS_LOADING:
      return {
        ...state,
        isLoading: true,
        // ... -> because hardcopy we cannot modify it
      };
    case UPDATE_PROJECT:
      let returnValue = state.projects;
      const indexOfItemInArray = returnValue.findIndex(
        (q) => q._id === action.payload._id
      );
      if (indexOfItemInArray > -1) {
        returnValue[indexOfItemInArray] = action.payload;
      }
      localStorage.setItem("projects", JSON.stringify(returnValue));
      return {
        ...state,
        projects: [
          ...returnValue,
          //   else return action.payload;
          // }
          // ...state.projects.filter(element => {
          //   if (element._id !== action.payload._id) return element;
          //   else return action.payload;
          // })
        ],
      };
    case LOGOUT_SUCCESS:
      localStorage.setItem("projects", JSON.stringify(null));
      localStorage.setItem("folder", JSON.stringify(null));
      return {
        ...state,
        isLoading: false,
        projects: null,
        folder: null,
        // ... -> because hardcopy we cannot modify it
      };
    default:
      return state;
  }
}
